import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const authHeaders = (token) => ({
  Authorization: `Bearer ${token || null || ""}`,
});

export async function createBusiness(payload, token) {
  const res = await axios.post(`${API}/businesses`, payload, {
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
  });
  return res.data;
}

export async function createSalonUnderBusiness(businessId, payload, token) {
  const res = await axios.post(`${API}/businesses/${businessId}/salons`, payload, {
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
  });
  return res.data;
}
